export default __webpack_public_path__ + "static/media/shea2.0f864223.jpg";